module.exports = __webpack_public_path__ + "img/j.e76b2f30.jpg";